import React from "react";
import PropTypes from "prop-types";
import { OverlayTrigger, Popover } from "react-bootstrap";

const qwoted100Image = RAILS_ASSET_URL("/qwoted100.png");

// Copy carried over verbatim from V1's Top100Badge so both platforms describe the list identically
// while V1 and V2 run in parallel; keep it word-for-word if you touch it.
const TOOLTIP_COPY =
  "A ranking member of our 'Qwoted 100' list – a collection of the best of the best in PR, based on feedback from Qwoted’s media users.";

/**
 * Qwoted100Badge — the "Qwoted 100" membership badge for person-shaped profiles.
 *
 * Presentational only: the badge image plus a hover/focus popover explaining the list. It does
 * NOT decide its own visibility — call sites render it only for members (e.g. when
 * useBadge("qwoted100", …) returns true), mirroring how FollowControl / GetQwotedCTA are gated by
 * their callers. Designed to be reused across profile engines.
 *
 * @param {Object} props
 * @param {number} [props.width] - Rendered image width in px (natural art is 169x55; height scales)
 */
function Qwoted100Badge({ width = 100 }) {
  return (
    <OverlayTrigger
      placement="auto"
      overlay={
        <Popover id="qwoted-100-badge-popover">
          <Popover.Body>{TOOLTIP_COPY}</Popover.Body>
        </Popover>
      }
    >
      <span className="d-inline-block" style={{ cursor: "help" }}>
        <img className="qwoted-100" src={qwoted100Image} alt="Qwoted 100" width={width} />
      </span>
    </OverlayTrigger>
  );
}

Qwoted100Badge.propTypes = {
  width: PropTypes.number,
};

export default Qwoted100Badge;
